import { type LensCompoundId } from "../../../gql-generated/types";

export const emptyCompoundId = Object.freeze<LensCompoundId>({
    id: null,
    reference: null,
    lensSourceType: null,
});
